import React from 'react';
import { SxProps, Typography, TypographyProps, Box } from '@mui/material';

export const SectionDescription = ({
  children,
  startIcon,
  sx,
  ...typographyProps
}: {
  children: React.ReactNode;
  startIcon?: React.ReactNode;
  sx?: SxProps;
  typographyProps?: TypographyProps<'span', { component?: 'span' }>;
}) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, pr: 1.5 }}>
    {startIcon && (
      <Box sx={{ pt: 0.25, height: '14px', '& svg': { fontSize: 14, color: 'grey.600' } }}>
        {startIcon}
      </Box>
    )}
    <Typography {...typographyProps} sx={{ fontSize: 14, color: 'black', ...sx }}>
      {children}
    </Typography>
  </Box>
);
